/**
 * @generated SignedSource<<e752299642ed42167875c14c4498dfef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectAdvertisementForm_TreeNodeFragment$data = {
  readonly id: string;
  readonly structureDefinition: {
    readonly extension?: {
      readonly advertisementConfig?: {
        readonly isFeatured: boolean;
      } | null | undefined;
    };
  };
  readonly " $fragmentType": "ProjectAdvertisementForm_TreeNodeFragment";
};
export type ProjectAdvertisementForm_TreeNodeFragment$key = {
  readonly " $data"?: ProjectAdvertisementForm_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectAdvertisementForm_TreeNodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectAdvertisementForm_TreeNodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "structureDefinition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "extension",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AdvertisementConfiguration",
                      "kind": "LinkedField",
                      "name": "advertisementConfig",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isFeatured",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "RootExtensionImpl",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "RootStructureDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};

(node as any).hash = "0ab6ec92509b525542a229a807b3143b";

export default node;
